import {global} from './utils/globals';
// @ts-ignore
global.probe = {};
